import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../config/axiosConfig';

export const fetchClients = createAsyncThunk('/clientdetails', async () => {
  const res = await axiosInstance.get(`/clientdetails`);
  return res.data;
});

export const updateClient = createAsyncThunk('client/updateClient', async ({ leadId, updatedData }) => {
  const res = await axiosInstance.put(`/clientdetails/update/${leadId}`, updatedData);
  return res.data;
});

export const deleteClient = createAsyncThunk('client/deleteClient', async (leadId) => {
  await axiosInstance.delete(`/clientdetails/delete/${leadId}`);
  return leadId;
});

const clientDetailsSlice = createSlice({
  name: 'client',
  initialState: {
    client: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(fetchClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.loading = false;
        state.client = action.payload;
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateClient.fulfilled, (state, action) => {
        const index = state.client.findIndex(c => c._id === action.payload._id);
        if (index !== -1) {
          state.client[index] = action.payload;
        }
      })
      .addCase(deleteClient.fulfilled, (state, action) => {
        state.client = state.client.filter(c => c._id !== action.payload);
      });
  },
});

export default clientDetailsSlice.reducer;
